<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { initSiteData, siteConfig } from './data/data.js'

onMounted(async () => {
  await initSiteData()
  document.title = siteConfig.title
  const descEl = document.querySelector('meta[name="description"]')
  if (descEl && siteConfig.description) descEl.setAttribute('content', siteConfig.description)
  const kwEl = document.querySelector('meta[name="keywords"]')
  if (kwEl && siteConfig.keywords) kwEl.setAttribute('content', siteConfig.keywords)
  printAscii()
})

function printAscii() {
  const logo = [
    '',
    '  8888888b.  Y88b   d88P Y88b   d88P 8888888b.  888b    888  .d8888b.',
    '  888   Y88b Y88b d88P   Y88b d88P  888  "Y88b 8888b   888 d88P  Y88b',
    '  888    888  Y88o88P     Y88o88P   888    888 88888b  888 Y88b.',
    '  888   d88P   Y888P       Y888P    888    888 888Y88b 888  "Y888b.',
    '  8888888P"    d888b       d888b    888    888 888 Y88b888     "Y88b.',
    '  888         d88888b     d88888b   888    888 888  Y88888       "888',
    '  888        d88P Y88b   d88P Y88b  888  .d88P 888   Y8888 Y88b  d88P',
    '  888       d88P   Y88b d88P   Y88b 8888888P"  888    Y888  "Y8888P"',
  ]
  console.log(logo.join('\n'))
  console.log(
    `%c ◐ PXXDNS · 派小星DNS二次元模板 | Version: ${siteConfig.version} `,
    'color: #e4467d; font-weight: bold; font-size: 14px;'
  )
}
</script>

<style>
body {
  margin: 0;
}
</style>
